import { useEffect, useState } from 'react';

import { Desktop } from '../../App';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import Spinner from '../../components/common/Spinner';
import { color } from '../../styles/GlobalStyles';
import { getDashboardInfo } from './Dashboard.actions';

import { Box, Flexed, SlideWrapper } from '../../styles/GlobalComponents';
import { DashboardNav } from './DashboardNav';

import 'swiper/css';
import 'swiper/css/navigation';

import Modal from 'react-modal';
import advertisementHub1 from '../../assets/images/backoffice/ad1.png';
import advertisementHub2 from '../../assets/images/backoffice/ad2.png';
import unitedOneBanner from '../../assets/images/backoffice/unitedOne/unitedOneBanner.png';
import { H3, H4, P2 } from '../../styles/FontStyles';
import MigrationTermsPrivacy from '../MigrationTermsPrivacy/MigrationTermsPrivacy';

import {
  isPartnerHelper,
  licenceExpiresIn30Days
} from '../../helpers/helperFunctions';
import { getCurrentLicense } from '../../slices/auth-slice';
import SignUp from '../SignUp/SignUp';
import { EarningsComponent } from './EarningsComponent';

import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import topPerformerUnderlay from '../../assets/images/topPerformerBack.png';
import topPerformerUnderlay2 from '../../assets/images/topPerformerBack2.png';
import { RankComponent } from '../Ranking/RankComponent';
import { getRanking } from '../Ranking/Ranking.actions';
import { TopSponsorPerformer } from './common/TopSponsorPerformer';
import { Ranking } from '../Ranking/Ranking';
import { TopPerformerOverlay } from './DashboardStyled';

export enum UserType {
  CUSTOMER = 1,
  PARTNER
}

const Dashboard = () => {
  const dispatch = useAppDispatch();
  const { userInfo } = useAppSelector((state) => state.auth);
  const [termsConditionsModal, setTermsConditionsModal] = useState(false);
  const [userTypeModal, setUserTypeModal] = useState(false);

  const [userType, setUserType] = useState(UserType.CUSTOMER);
  const { dashboardInfo, loading } = useAppSelector((state) => state.dashboard);

  const user = userInfo.user;

  const isPartner = isPartnerHelper(
    dashboardInfo?.user?.currentVirtualOfficeLicence?.dateEnd || ''
  );

  const { ranking, loading: rankingLoading } = useAppSelector(
    (state) => state.ranking
  );

  useEffect(() => {
    if (!userInfo.isFirstLoginPopupChecked) {
      dispatch(getCurrentLicense());
      setUserTypeModal(true);
    } else if (!userInfo.isMavieMigrationModalChecked) {
      dispatch(getCurrentLicense());
      setTermsConditionsModal(true);
    }
    dispatch(getDashboardInfo());
    if (isPartner) {
      dispatch(getRanking());
    }
  }, [dispatch, userInfo.isMavieMigrationModalChecked, isPartner]);

  if (loading || (rankingLoading && !dashboardInfo))
    return <Spinner fullScreen={true} />;

  return (
    <AnimatedDashboard zoom key={'dashboardInfo'}>
      <Flexed gap='20px' rowSM width='100%'>
        {!isPartner && (
          <Flexed width='30%' widthSM='100%'>
            <Box
              style={{ width: '100%', marginBottom: 0 }}
              p='46px 36px'
              pSM='46px 36px'
              mSM='0'
              mbSM='0'>
              <DashboardNav user={user} />
            </Box>
          </Flexed>
        )}
        <Flexed
          column
          width={isPartner ? '100%' : '70%'}
          widthSM='100%'
          gap='20px'>
          <Desktop>
            <Flexed>
              <img
                src={unitedOneBanner}
                alt='flipMeBanner'
                style={{ width: '100%', marginBottom: 0 }}
              />
            </Flexed>
          </Desktop>
          {isPartner && (
            <Flexed gap='20px' rowSM width='100%'>
              <Flexed column width='45%' widthSM='100%' gap='20px'>
                {isPartner && (
                  <div style={{ width: '100%' }}>
                    <EarningsComponent user={user} backOffice={dashboardInfo} />
                  </div>
                )}
                {isPartner && ranking && ranking.length > 0 && (
                  <Ranking ranking={ranking} isDashboard={true} />
                )}
                <Box
                  relative
                  overflow='hidden'
                  m='0'
                  style={{ marginBottom: 0 }}>
                  <H4
                    fontFamily='Nulshock'
                    caps
                    color={color.colors.primary900}
                    mb='20'>
                    Advertisement hub
                  </H4>

                  <SlideWrapper
                    width='calc(100% + 48px)'
                    margin='0 -24px 0px -24px'>
                    <Swiper
                      slidesPerView={1.2}
                      modules={[Navigation]}
                      navigation={true}
                      spaceBetween={10}
                      centeredSlides={true}>
                      <SwiperSlide>
                        <img
                          src={advertisementHub1}
                          alt='advertisement hub 1'
                          style={{ width: '100%' }}
                        />
                      </SwiperSlide>
                      <SwiperSlide>
                        <img
                          src={advertisementHub2}
                          alt='advertisement hub 2'
                          style={{ width: '100%' }}
                        />
                      </SwiperSlide>
                    </Swiper>
                  </SlideWrapper>
                </Box>
              </Flexed>
              <Flexed column gap='20px' width='55%' widthSM='100%'>
                <Box
                  relative
                  overflow='hidden'
                  m='0'
                  style={{ marginBottom: 0 }}
                  bg={`url(${topPerformerUnderlay})`}
                  bgSize='cover'
                  bgPosition='center'
                  bgRepeat='no-repeat'>
                  <Flexed center between mb='15'>
                    <H4 fontFamily='Nulshock' color={color.colors.primary900}>
                      Top Sponsor
                    </H4>
                    <P2 right color={color.colors.primary900}>
                      Combo sales this week
                    </P2>
                  </Flexed>
                  <TopSponsorPerformer user={user} index={0} />
                  <TopSponsorPerformer user={user} index={1} />
                  <TopSponsorPerformer user={user} index={2} />
                  <TopSponsorPerformer user={user} index={3} />
                  <TopSponsorPerformer user={user} index={4} />
                  <TopSponsorPerformer user={user} index={5} />
                  <TopPerformerOverlay>
                    <H3 color={color.colors.primary900}>COMING SOON</H3>
                  </TopPerformerOverlay>
                </Box>
                <Box
                  relative
                  overflow='hidden'
                  m='0'
                  style={{ marginBottom: 0 }}
                  bg={`url(${topPerformerUnderlay2})`}
                  bgSize='cover'
                  bgPosition='center'
                  bgRepeat='no-repeat'>
                  <Flexed center between mb='15'>
                    <H4 fontFamily='Nulshock' color={color.colors.primary900}>
                      Top Performer
                    </H4>
                    <P2 color={color.colors.primary900}>
                      Direct volume this week
                    </P2>
                  </Flexed>
                  <TopSponsorPerformer user={user} index={0} />
                  <TopSponsorPerformer user={user} index={1} />
                  <TopSponsorPerformer user={user} index={2} />
                  <TopSponsorPerformer user={user} index={3} />
                  <TopSponsorPerformer user={user} index={4} />
                  <TopSponsorPerformer user={user} index={5} />
                  <TopPerformerOverlay>
                    <H3 color={color.colors.primary900}>COMING SOON</H3>
                  </TopPerformerOverlay>
                </Box>
              </Flexed>
            </Flexed>
          )}
          {!isPartner && (
            <Flexed gap='20px' rowSM width='100%'>
              <Flexed column width='50%' widthSM='100%'>
                <img
                  src={advertisementHub1}
                  alt='advertisement hub 1'
                  style={{ width: '100%' }}
                />
              </Flexed>
              <Flexed column width='50%' widthSM='100%'>
                <img
                  src={advertisementHub2}
                  alt='advertisement hub 2'
                  style={{ width: '100%' }}
                />
              </Flexed>
            </Flexed>
          )}
        </Flexed>
      </Flexed>

      <Modal
        isOpen={userTypeModal}
        contentLabel='Terms Conditions'
        className={'termsModalDashboard'}
        overlayClassName='myoverlay2'
        closeTimeoutMS={500}
        ariaHideApp={false}>
        <SignUp
          setUserTypeModal={setUserTypeModal}
          setTermsConditionsModal={setTermsConditionsModal}
          setUserType={setUserType}
        />
      </Modal>
      <Modal
        isOpen={termsConditionsModal}
        contentLabel='Terms Conditions'
        className={'termsModalDashboard'}
        overlayClassName='myoverlay2'
        closeTimeoutMS={500}
        ariaHideApp={false}>
        <MigrationTermsPrivacy
          setTermsConditionsModal={setTermsConditionsModal}
          isMavieMigrationModalChecked={userInfo?.isMavieMigrationModalChecked}
          userType={userType}
        />
      </Modal>
    </AnimatedDashboard>
  );
};

export default Dashboard;
